import React, { useState, useEffect } from "react";
import { getAllGenres, getMoviesByGenres } from "../services/movieApi";
import MovieList from "../components/MovieList";
import { useParams, useNavigate } from "react-router-dom";
import "./GenreMovies.scss";

const GenreMovies = () => {
    const [genreMovies, setGenreMovies] = useState([]);
    const [allGenres, setAllGenres] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(null);
    const [loadingGenreMovies, setLoadingGenreMovies] = useState(false);
    const [loadingAllGenres, setLoadingAllGenres] = useState(false);
    const { genreId, pageNumber } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchGenreMovies = async () => {
            setLoadingGenreMovies(true);
            const data = await getMoviesByGenres(genreId, pageNumber);
            setGenreMovies(data.results);
            setCurrentPage(data.page);
            setTotalPages(data.total_pages);
            setLoadingGenreMovies(false);
        };

        const fetchAllGenres = async () => {
            setLoadingAllGenres(true);
            const data = await getAllGenres();
            setAllGenres(data.genres);
            setLoadingAllGenres(false);
        };
        fetchGenreMovies();
        fetchAllGenres();
    }, [pageNumber, genreId]);

    let prevPage = currentPage - 1;
    let nextPage = currentPage + 1;

    const handleNextPageReq = () => {
        if (nextPage <= totalPages) {
            pageReq(nextPage);
        }
    };

    const handlePrevPageReq = () => {
        if (prevPage > 0) {
            pageReq(prevPage);
        }
    };

    const pageReq = async (page) => {
        try {
            navigate(`/genre/${genreId}/page/${page}`);
        } catch (error) {
            console.error("Error changing page: ", error);
        }
    };

    const findGenreNameById = (id) => {
        if (allGenres !== null) {
            const foundGenre = allGenres.find(
                (genre) => genre.id.toString() === id
            );
            return foundGenre ? foundGenre.name : "";
        }
    };

    const genreName = findGenreNameById(genreId);

    return (
        <div className="genre-movies layout">
            {loadingAllGenres ? (
                <p>Loading...</p>
            ) : (
                <h1>{genreName && `${genreName} Movies`}</h1>
            )}
            {loadingGenreMovies ? (
                <p>Loading...</p>
            ) : (
                <>
                    <MovieList movies={genreMovies} />
                    <div className="pagination">
                        <button
                            className={`prev ${
                                prevPage === 0 ? "noclick" : ""
                            }`}
                            onClick={handlePrevPageReq}
                        >
                            Prev
                        </button>
                        <button className="pagination-button">
                            {currentPage}
                        </button>
                        <button
                            className={`next ${
                                nextPage === totalPages + 1 ? "noclick" : ""
                            }`}
                            onClick={handleNextPageReq}
                        >
                            Next
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default GenreMovies;
